"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogAssetFilterMap = exports.catalogAssetSortMap = exports.CatalogAssetType = void 0;
var CatalogAssetType;
(function (CatalogAssetType) {
    CatalogAssetType["Dataset"] = "dataset";
    CatalogAssetType["PipelineFragment"] = "pipeline-fragment";
    CatalogAssetType["Model"] = "model";
    CatalogAssetType["App"] = "app";
})(CatalogAssetType || (exports.CatalogAssetType = CatalogAssetType = {}));
exports.catalogAssetSortMap = {
    catalogAssetId: "id",
    name: "name",
    description: "description",
    assetType: "asset_type",
    lineageId: "lineage_id",
    version: "version",
    isLatestVersion: "is_latest_version",
    createdAt: "created_at",
    createdByUser_userId: "created_by_user_id",
    createdByUser_name: "createdByName",
    createdByUser_username: "createdByUsername",
    createdByUser_email: "createdByEmail",
    projectId: "project_id",
    internalLinkId: "internal_link_id",
    resourceName: "resource_name",
};
exports.catalogAssetFilterMap = {
    catalogAssetId: "ca.id",
    name: "ca.name",
    description: "ca.description",
    assetType: "ca.asset_type",
    lineageId: "ca.lineage_id",
    version: "ca.version",
    isLatestVersion: "ca.is_latest_version",
    createdAt: "ca.created_at",
    createdByUser_userId: "ca.created_by_user_id",
    createdByUser_name: "u.name",
    createdByUser_username: "u.username",
    createdByUser_email: "u.email",
    projectId: "ca.project_id",
    internalLinkId: "ca.internal_link_id",
    resourceName: "ca.resource_name",
};
